<div>
    <app-charge-type-form></app-charge-type-form>
</div>
<div>
    <app-charge-type-list></app-charge-type-list>
</div>
